const toDateObject = (value) => {
  if (!value) return null;

  if (typeof value?.toDate === 'function') {
    return value.toDate();
  }

  if (value instanceof Date) {
    return value;
  }

  const parsedDate = new Date(value);
  return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export const formatCurrency = (value, currency = 'SAR') => {
  const amount = Number(value ?? 0);

  return new Intl.NumberFormat('en-SA', {
    style: 'currency',
    currency,
    maximumFractionDigits: 2,
  }).format(Number.isFinite(amount) ? amount : 0);
};

export const formatDate = (value, options = {}) => {
  const date = toDateObject(value);
  if (!date) return 'N/A';

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    ...options,
  }).format(date);
};

export const formatDateTime = (value, options = {}) => {
  const date = toDateObject(value);
  if (!date) return 'N/A';

  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...options,
  }).format(date);
};

export const normalizeBookingStatus = (status) => {
  if (!status) return 'pending';

  const normalized = String(status).trim().toLowerCase().replace(/\s+/g, '_').replace(/-/g, '_');

  if (['active', 'in_progress', 'inprogress', 'ongoing', 'checked_in'].includes(normalized)) {
    return 'ongoing';
  }

  if (['payment_pending', 'paymentpending'].includes(normalized)) {
    return 'pending';
  }

  if (['approved', 'accepted'].includes(normalized)) {
    return 'confirmed';
  }

  if (['finished'].includes(normalized)) {
    return 'completed';
  }

  return normalized;
};

export const getBookingAmount = (booking) => {
  const candidates = [
    booking?.totalPrice,
    booking?.totalAmount,
    booking?.amount,
    booking?.monthlyRent,
    booking?.price,
    booking?.bookingAmount,
  ];

  for (const candidate of candidates) {
    if (candidate === null || candidate === undefined || candidate === '') continue;

    const numericValue = Number(candidate);
    if (Number.isFinite(numericValue)) {
      return numericValue;
    }
  }

  return 0;
};

export const getNotificationLabel = (type) => {
  if (!type) return 'Notification';

  return String(type)
    .replace(/_/g, ' ')
    .replace(/([a-z])([A-Z])/g, '$1 $2')
    .replace(/\b\w/g, (letter) => letter.toUpperCase());
};